import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import i18next from "i18next";

const updateFavoriteStatus = (list, propertyId, isFavorite) => {
  if (list) {
    return list.map((property) =>
      property.uuid === propertyId
        ? { ...property, isFavourite: isFavorite }
        : property
    );
  }
  return list;
};

const propertySlice = createSlice({
  name: "property",
  initialState: {
    propertyList: null,
    propertySignatureList: null,
    totalPages: 0,
    currentPage: 0,
    propertyExploreList: null,
    propertyDetail: null,
    loading: false,
    loadingMore: false,
    loadingImg: false,
    error: null,
    tagOptionList: [],
    selectedFeatures: [],
    imageList: [],
    userPropertyList: [],
    userPropertyLoading: false,
    userPropertyError: null,
    propertyDeleteLoading: false,
    propertyDeleteError: null,
    propertyHideLoading: false,
    propertyEditLoading: false,
    propertySuccess: false,
    userPropertyCurrentPage: 1,
    userPropertyTotalPages: 1,
    loadingFav: false,
    myPropertyList: [],
    myPropertyLoading: false,
    myPropertyError: null,
    myPropertyCurrentPage: 1,
    myPropertyTotalPages: 1,
    // filter data
    maxPropertyPrice: null,
    minPropertyPrice: null,
    propertyType: null,
    propertyLatitude: null,
    propertyLongitude: null,
    geoLocation: null,
    minPropertySize: null,
    maxPropertySize: null,
    filterObject: null,
    aiSearchResults: null,
    aiSearchRedirect: false,
    compareProperties: [],
    comparisonPropertyIds: [],
    favouritePropertiesList: [],
    favouritePropertiesLoading: false,
    favouritePropertiesError: null,
    favouritePropertyCurrentPage: 0,
    favouritePropertyTotalPages: 0,
    aiSearchLoading: false,
    locationLatLng: null,
    changedFilterCount: 0,
    countryBasedPropertyList: [],
    propertySignatureListCount: null,
    propertyListCount: null
  },
  reducers: {
    // Property actions
    propertyRequest: (state, action) => {
      const { isPagination, params } = action.payload;
      state.loading = true;
      state.error = null;
      state.propertyList = !isPagination ? null : [...state.propertyList];
      state.propertyListCount = null;
      state.currentPage = !params.page ? 0 : params.page;
      state.loadingMore = !params.page ? false : true;
    },
    propertySuccess: (state, action) => {
      const data = action.payload;
      state.propertyList =
        state.propertyList && data?.currentPage != 0
          ? [...state.propertyList, ...data.properties]
          : data.properties;
      state.propertyListCount = data.totalCount;
      state.totalPages = data.totalPages - 1;
      state.loading = false;
      state.loadingMore = false;
      state.error = null;
    },
    propertyFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
      state.loadingMore = false;
      state.isLogin = false;
      state.propertyList = null;
    },
    propertySignatureRequest: (state, action) => {
      const { isPagination, params } = action.payload;
      state.loading = true;
      state.error = null;
      state.propertySignatureList =
        !isPagination || !params?.page
          ? null
          : [...state.propertySignatureList];
      state.propertySignatureListCount = null;
      state.currentPage = !params.page ? 0 : params.page;
      state.loadingMore = !params.page ? false : true;
    },
    propertySignatureSuccess: (state, action) => {
      const data = action.payload;

      state.propertySignatureList =
        state.propertySignatureList && !!data?.currentPage != 0
          ? [...state.propertySignatureList, ...data.properties]
          : data.properties;
      state.propertySignatureListCount = data.totalCount;
      state.totalPages = data.totalPages - 1;
      state.loading = false;
      state.loadingMore = false;
      state.error = null;
    },
    propertySignatureFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
      state.loadingMore = false;
      state.isLogin = false;
      state.propertySignatureList = null;
    },

    filterStateRequest: (state, action) => {
      state.filterObject = { ...state.filterObject, ...action.payload };
    },

    resetFilterState: (state) => {
      state.filterObject = {};
    },

    // its seems use less calls
    explorePropertyRequest: (state) => {
      state.propertyExploreList = null;
    },
    explorePropertySuccess: (state, action) => {
      const data = action.payload;
      state.propertyExploreList = data;
      state.propertyList = data.properties;
    },
    explorePropertyFailure: (state) => {
      state.propertyExploreList = null;
    },
    propertyDetailRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.propertyDetail = null;
    },
    resetPropertyDetail: (state) => {
      state.propertyDetail = null;
    },
    propertyDetailSuccess: (state, action) => {
      const data = action.payload;
      state.propertyDetail = data;
      state.loading = false;
      state.error = null;
    },
    propertyDetailFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
      state.isLogin = false;
    },
    // Filter
    propertyFilterRequest: (state) => {
      state.loading = true;
      state.propertyList = null;
      state.propertySignatureList = null;
      state.propertySignatureList = null;
      state.propertySignatureListCount = null;
      state.error = null;
      state.currentPage = 0;
      state.totalPages = 0;
      state.loadingMore = false;
    },
    propertyFilterSuccess: (state, action) => {
      const data = action.payload;
      state.propertyList = data.properties;
      state.propertyListCount = data.totalCount;
      state.propertySignatureList = data.properties;
      state.propertySignatureListCount = data.totalCount;
      state.totalPages = data.totalPages - 1;
      state.loading = false;
      state.loadingMore = false;
      state.error = null;
    },
    propertyFilterFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
      state.isLogin = false;
    },
    setSelectedFeatures: (state, action) => {
      state.selectedFeatures = action.payload;
    },
    fetchTagsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchTagsSuccess: (state, action) => {
      state.tagOptionList = action.payload;
      state.loading = false;
    },
    fetchTagsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    savePropertyRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.propertySuccess = false;
    },
    savePropertySuccess: (state) => {
      notification.success({
        message: i18next.t("addProperty.addSuccessTitle"),
        description: i18next.t("addProperty.addSuccessMessage"),
        placement: "topRight"
      });
      state.propertySuccess = true;
    },
    savePropertyFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.propertySuccess = false;
      notification.error({
        message: i18next.t("myProperties.propertyAddFailed"),
        description: action?.payload?.response?.data?.details[0],
        placement: "topRight"
      });
    },
    setImageList: (state, action) => {
      state.imageList = action.payload;
    },
    savePropertyImageRequest: (state) => {
      state.loadingImg = true;
      state.error = null;
    },
    savePropertyImageSuccess: (state) => {
      state.loadingImg = false;
      state.loading = false;
      state.propertyEditLoading = false;
    },
    savePropertyImageFailure: (state, action) => {
      state.loadingImg = false;
      state.loading = false;
      state.error = action.payload;
    },
    propertiesByUserRequest: (state, action) => {
      const { page } = action.payload;
      state.userPropertyList = page === 0 ? [] : state.userPropertyList;
      state.userPropertyLoading = true;
      state.userPropertyError = null;
    },
    propertiesByUserSuccess: (state, action) => {
      const { properties = [], totalPages, currentPage } = action.payload;

      const newProperties = properties?.filter(
        (property) =>
          !state.userPropertyList.some(
            (existingProperty) => existingProperty.uuid === property.uuid
          )
      );

      state.userPropertyList = [...state.userPropertyList, ...newProperties];
      state.userPropertyTotalPages = totalPages;
      state.userPropertyCurrentPage = currentPage;
      state.userPropertyLoading = false;
      state.userPropertyError = null;
    },
    propertiesByUserFailure: (state) => {
      state.userPropertyList = null;
      state.userPropertyLoading = false;
      state.userPropertyError = null;
    },
    myPropertiesRequest: (state, action) => {
      const { page } = action.payload;
      state.myPropertyList = page === 0 ? [] : state.myPropertyList;
      state.myPropertyLoading = true;
      state.myPropertyError = null;
    },
    myPropertiesSuccess: (state, action) => {
      const { properties = [], totalPages, currentPage } = action.payload;

      const newProperties = properties?.filter(
        (property) =>
          !state.myPropertyList.some(
            (existingProperty) => existingProperty.uuid === property.uuid
          )
      );

      state.myPropertyList = [...state.myPropertyList, ...newProperties];
      state.myPropertyTotalPages = totalPages;
      state.myPropertyCurrentPage = currentPage;
      state.myPropertyLoading = false;
      state.myPropertyError = null;
    },
    myPropertiesFailure: (state) => {
      state.myPropertyList = null;
      state.myPropertyLoading = false;
      state.myPropertyError = null;
    },
    propertyDeleteRequest: (state) => {
      state.propertyDeleteLoading = true;
      state.propertyDeleteError = null;
    },
    propertyDeleteSuccess: (state, action) => {
      const { uuid } = action.payload;

      state.propertyDeleteLoading = false;
      state.propertyDeleteError = null;

      if (uuid) {
        state.myPropertyList = state.myPropertyList?.filter(
          (property) => property.uuid !== uuid
        );
      }
      notification.success({
        message: i18next.t("myProperties.delete.successTitle"),
        description: i18next.t("myProperties.delete.successMessage"),
        placement: "topRight"
      });
    },
    propertyDeleteFailure: (state, action) => {
      state.propertyDeleteLoading = false;
      state.propertyDeleteError = action.payload;
      notification.error({
        message: i18next.t("myProperties.propertyDeleteFailed"),
        description: action?.payload?.response?.data?.message,
        placement: "topRight"
      });
    },

    propertyHideRequest: (state) => {
      state.propertyHideLoading = true;
    },
    propertyHideSuccess: (state, action) => {
      const { uuid, hideProperty, updatedPropertyData } = action.payload;
      const actionKey = hideProperty ? "hide" : "show";
      state.propertyHideLoading = false;

      state.myPropertyList = state.myPropertyList?.map((property) =>
        property.uuid === uuid
          ? {
              ...property,
              hideProperty: hideProperty,
              ...updatedPropertyData
            }
          : property
      );

      notification.success({
        message: i18next.t(`myProperties.${actionKey}.successTitle`),
        description: i18next.t(`myProperties.${actionKey}.successMessage`),
        placement: "topRight"
      });
    },
    propertyHideFailure: (state, action) => {
      state.propertyHideLoading = false;
      notification.error({
        message: i18next.t("myProperties.propertyHideFailed"),
        description: action?.payload?.response?.data?.message,
        placement: "topRight"
      });
    },

    editPropertyRequest: (state) => {
      state.propertyEditLoading = true;
      state.propertySuccess = false;
    },
    editPropertySuccess: (state) => {
      state.propertyEditLoading = false;
      notification.success({
        message: i18next.t("myProperties.edit.successTitle"),
        description: i18next.t("myProperties.edit.successMessage"),
        placement: "topRight"
      });
      state.propertySuccess = true;
    },
    editPropertyFailure: (state, action) => {
      state.propertyEditLoading = false;
      state.propertySuccess = false;
      notification.error({
        message: i18next.t("myProperties.propertyEditFailed"),
        description: action?.payload?.response?.data?.details[0],
        placement: "topRight"
      });
    },
    resetPropertySuccess: (state) => {
      state.propertySuccess = false;
    },
    resetUserPropertiesList: (state) => {
      state.userPropertyList = [];
    },
    aiSearchRedirectRequest: (state) => {
      state.aiSearchRedirect = false;
    },
    aiSearchRequest: (state) => {
      state.aiSearchResults = null;
      state.aiSearchLoading = true;
    },
    aiSearchSuccess: (state, action) => {
      state.aiSearchLoading = false;
      state.aiSearchResults = action.payload.data;
      state.aiSearchRedirect = true;
      notification.success({
        message: i18next.t("header.aiSearchCompleted"),
        placement: "topRight"
      });
    },
    aiSearchFailure: (state, action) => {
      state.aiSearchLoading = false;
      notification.error({
        message: i18next.t("myProperties.aiSearchFailedTitle"),
        description:
          action?.payload?.response?.data?.detail ||
          i18next.t("myProperties.aiSearchFailedMessage"),
        placement: "topRight"
      });
    },
    deletePropertyImageRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    deletePropertyImageSuccess: (state, action) => {
      const { propertyImageId } = action.payload;
      state.imageList = state.imageList?.filter(
        (image) => image?.id !== propertyImageId
      );
      state.loading = false;
      notification.success({
        message: i18next.t("profileSettings.imageDeletedTitle"),
        description: i18next.t("profileSettings.imageDeletedMessage"),
        placement: "topRight"
      });
    },

    deletePropertyImageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      notification.error({
        message: i18next.t("myProperties.imageDeleteFailed"),
        description: action?.payload?.response?.data?.message,
        placement: "topRight"
      });
    },
    getCompareProperties: (state) => {
      state.loading = true;
      state.compareProperties = [];
    },
    comparePropertiesSuccess: (state, action) => {
      state.loading = false;
      state.compareProperties = action.payload;
    },
    comparePropertiesFailure: (state, action) => {
      state.loading = false;
      notification.error({
        message: i18next.t("myProperties.genericError"),
        description:
          action?.payload?.response?.data?.detail ||
          i18next.t("myProperties.comparisonFailed"),
        placement: "topRight"
      });
    },
    togglePropertyComparison: (state, action) => {
      const property = action.payload;
      const index = state.comparisonPropertyIds.findIndex(
        (item) => item.uuid === property.uuid
      );
      if (index !== -1) {
        state.comparisonPropertyIds = state.comparisonPropertyIds.filter(
          (item) => item.uuid !== property.uuid
        );
      } else if (state.comparisonPropertyIds.length < 3) {
        state.comparisonPropertyIds.push(property);
      }
    },
    markPropertyAsFavoriteRequest: (state, action) => {
      state.loadingFav = true;
      const { propertyId } = action.payload;
      if (state.propertyExploreList) {
        state.propertyExploreList.properties = updateFavoriteStatus(
          state?.propertyExploreList?.properties,
          propertyId,
          true
        );
      }
      state.propertyList = updateFavoriteStatus(
        state?.propertyList,
        propertyId,
        true
      );
      state.propertySignatureList = updateFavoriteStatus(
        state?.propertySignatureList,
        propertyId,
        true
      );
      state.userPropertyList = updateFavoriteStatus(
        state?.userPropertyList,
        propertyId,
        true
      );

      if (state.propertyDetail) {
        state.propertyDetail = {
          ...state?.propertyDetail,
          isFavourite: true
        };
      }
    },
    markPropertyAsFavoriteSuccess: (state) => {
      state.loadingFav = false;
    },
    markPropertyAsFavoriteFailure: (state, action) => {
      state.loadingFav = false;
      state.error = action.payload;
      notification.error({
        message: i18next.t("myProperties.markFailedTitle"),
        description: i18next.t("myProperties.markFailedMessage"),
        placement: "topRight"
      });
    },
    unMarkPropertyAsFavoriteRequest: (state, action) => {
      state.loadingFav = true;
      const { propertyId } = action.payload;
      if (state.propertyExploreList?.properties) {
        state.propertyExploreList.properties = updateFavoriteStatus(
          state?.propertyExploreList?.properties,
          propertyId,
          false
        );
      }
      state.propertyList = updateFavoriteStatus(
        state?.propertyList,
        propertyId,
        false
      );
      state.propertySignatureList = updateFavoriteStatus(
        state?.propertySignatureList,
        propertyId,
        false
      );
      state.userPropertyList = updateFavoriteStatus(
        state?.userPropertyList,
        propertyId,
        false
      );

      if (state.favouritePropertiesList) {
        state.favouritePropertiesList = state.favouritePropertiesList.filter(
          (property) => property.uuid !== propertyId || !property.isFavourite
        );
      }

      if (state.propertyDetail) {
        state.propertyDetail = {
          ...state.propertyDetail,
          isFavourite: false
        };
      }
    },
    unMarkPropertyAsFavoriteSuccess: (state) => {
      state.loadingFav = false;
    },
    unMarkPropertyAsFavoriteFailure: (state, action) => {
      state.loadingFav = false;
      state.error = action.payload;
      notification.error({
        message: i18next.t("myProperties.removeFailedTitle"),
        description: i18next.t("myProperties.removeFailedMessage"),
        placement: "topRight"
      });
    },

    // ✅ Clear All Compared Properties
    clearComparisonProperties: (state) => {
      state.comparisonPropertyIds = {};
    },
    favouritePropertiesRequest: (state) => {
      state.favouritePropertiesLoading = true;
    },
    favouritePropertiesSuccess: (state, action) => {
      const { properties = [], totalPages, currentPage } = action.payload;

      const newProperties = properties?.filter(
        (property) =>
          !state.favouritePropertiesList?.some(
            (existingProperty) => existingProperty?.uuid === property?.uuid
          )
      );

      state.favouritePropertiesList = [
        ...state.favouritePropertiesList,
        ...newProperties
      ];
      state.favouritePropertyTotalPages = totalPages;
      state.favouritePropertyCurrentPage = currentPage;
      state.favouritePropertiesLoading = false;
    },

    favouritePropertiesFailure: (state, action) => {
      state.favouritePropertiesLoading = false;
      state.favouritePropertiesError = action?.payload?.response?.data?.message;
      notification.error({
        message: i18next.t("myProperties.favoriteFailed"),
        description: action?.payload?.response?.data?.message,
        placement: "topRight"
      });
    },

    resetFavouritePropertiesList: (state) => {
      state.favouritePropertiesList = [];
    },
    addCountAsPropertyViewRequest: (state) => {
      state.addCountAsPropertyViewLoading = true;
    },
    addCountAsPropertyViewSuccess: (state) => {
      state.addCountAsPropertyViewLoading = false;
    },
    addCountAsPropertyViewFailure: (state) => {
      state.addCountAsPropertyViewLoading = false;
    },
    setLocationLatLng: (state, action) => {
      state.locationLatLng = action.payload;
    },
    setStateFilterCount: (state, action) => {
      const count = action.payload;
      state.changedFilterCount = count;
    },

    countryBasedPropertyRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    countryBasedPropertySuccess: (state, action) => {
      const data = action.payload;
      state.countryBasedPropertyList = data;
      state.loading = false;
      state.error = null;
    },
    countryBasedPropertyFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
      state.isLogin = false;
    }
  }
});

export const {
  propertyRequest,
  propertySuccess,
  propertyFailure,
  explorePropertyRequest,
  explorePropertySuccess,
  explorePropertyFailure,
  propertyDetailRequest,
  propertyDetailSuccess,
  propertyDetailFailure,
  resetPropertyDetail,
  propertyFilterRequest,
  propertyFilterSuccess,
  propertyFilterFailure,
  setSelectedFeatures,
  fetchTagsRequest,
  fetchTagsSuccess,
  fetchTagsFailure,
  savePropertyRequest,
  savePropertySuccess,
  savePropertyFailure,
  setImageList,
  savePropertyImageRequest,
  savePropertyImageSuccess,
  savePropertyImageFailure,
  propertiesByUserRequest,
  propertiesByUserSuccess,
  propertiesByUserFailure,
  myPropertiesRequest,
  myPropertiesSuccess,
  myPropertiesFailure,
  propertyDeleteRequest,
  propertyDeleteSuccess,
  propertyDeleteFailure,
  propertyHideRequest,
  propertyHideSuccess,
  propertyHideFailure,
  editPropertyRequest,
  editPropertySuccess,
  editPropertyFailure,
  resetPropertySuccess,
  resetUserPropertiesList,
  filterStateRequest,
  resetFilterState,
  aiSearchSuccess,
  aiSearchRequest,
  aiSearchFailure,
  aiSearchRedirectRequest,
  deletePropertyImageRequest,
  deletePropertyImageSuccess,
  deletePropertyImageFailure,
  getCompareProperties,
  comparePropertiesFailure,
  comparePropertiesSuccess,
  togglePropertyComparison,
  clearComparisonProperties,
  markPropertyAsFavoriteRequest,
  markPropertyAsFavoriteSuccess,
  markPropertyAsFavoriteFailure,
  unMarkPropertyAsFavoriteRequest,
  unMarkPropertyAsFavoriteSuccess,
  unMarkPropertyAsFavoriteFailure,
  favouritePropertiesRequest,
  favouritePropertiesSuccess,
  favouritePropertiesFailure,
  resetFavouritePropertiesList,
  addCountAsPropertyViewRequest,
  addCountAsPropertyViewSuccess,
  addCountAsPropertyViewFailure,
  propertySignatureRequest,
  propertySignatureSuccess,
  propertySignatureFailure,
  setStateFilterCount,
  setLocationLatLng,
  countryBasedPropertyRequest,
  countryBasedPropertySuccess,
  countryBasedPropertyFailure
} = propertySlice.actions;

export default propertySlice.reducer;
